import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

    public overlayClassName: string = "overlay-dormant";
    public spinnerOverlayClassName: string = "spinner-overlay-dormant";

    public constructor(public appService: AppService) {

        this.appService.isAppBusySubject.subscribe((isAppBusy) => {

            if (isAppBusy != undefined) {

                if (isAppBusy == true) {

                    this.overlayClassName = "overlay-loading";
                    this.spinnerOverlayClassName = "spinner-overlay-loading";

                } else {

                    // FIXED: use the CSS-defined dormant class name (was "loader-overlay-dormant" — incorrect)
                    this.overlayClassName = "overlay-dormant";
                    this.spinnerOverlayClassName = "spinner-overlay-dormant";
                }
            }
        });
    }

    public ngOnInit(): void { }
}
